export const PendingImageLink = "https://img.icons8.com/ios/50/3054EA/new-company.png";
export const ResubImageLink = "https://img.icons8.com/ios-filled/50/FFBA32/submit-progress.png";
export const CompleteImageLink =
	"https://img.icons8.com/material-outlined/50/6EEDA8/checkmark--v1.png";
export const RejectedImageLink = "https://img.icons8.com/office/50/000000/delete-sign.png";
export const CancelationIconLink = "https://img.icons8.com/dotty/50/e64a19/cancel-subscription.png";
export const DuplicateIconsLink = "https://img.icons8.com/ios/50/039be5/duplicate.png";
export const UploadVerification = "https://img.icons8.com/ios/50/37804D/upload-document.png";
export const ClarificationIcon = "https://img.icons8.com/dotty/80/e64a19/note.png";
